<template>
  <div class="login">
    <v-layout column align-center>
      <v-card width="450px" class="pt-0 info">
          <v-card-text class="font-weight-bold">
            <v-icon small class="orange--text">mdi-information</v-icon>
            This is the mobile version of Envoy for you to monitor your submissions and files.  Please use the <a class="blue--text text--darken-4" @click="desktop_version_link">desktop version</a> to install plugins, submit jobs and up/download files
          </v-card-text>
        </v-card>
      <template>
        <v-dialog v-model="linkedin_auth" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Signing in via LinkedIn...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-if="!linkedin_auth">
        <v-card width="450px" class="mt-4">
          <v-alert v-if="login_error" class="error my-0 pa-2" tile>
            <v-icon small class="pb-1">warning</v-icon>
            <span class="subtitle-1 font-weight-medium pl-2">{{login_error}}</span>
          </v-alert>
          <v-card-text>
              <v-text-field v-model="email" :rules="emailRules" label="Email" autofocus required v-on:keyup.enter="submit"></v-text-field>
              <v-text-field type="password" v-model="password" :rules="passwordRules" :label="password_label" required v-on:keyup.enter="submit"></v-text-field>
              <div class="text-right">
                <button class="float-left mt-1" @click="linkedin_signin" :disabled="login_disabled">
                  <v-img src="linkedin-signin-default.png"/>
                </button>
                <v-btn x-small class="primary" @click="submit" :disabled="login_disabled" :loading="login_loading">Login</v-btn>
                <br/>
                <a class="caption" @click="forgot_password">Forgot Password</a>
              </div>
          </v-card-text>
        </v-card>
        <v-card width="450px" class="mt-4">
          <v-card-text>
            <v-icon small>mdi-help</v-icon>
            Login with your password to submit jobs or with the Access Key provided to you to only access project files
          </v-card-text>
        </v-card>
      </template>
      <v-alert v-if="text_from_envoy" width="450px" class="orange">
        {{text_from_envoy}}
      </v-alert>

      <v-dialog v-model="notifications_dialog" width="450" overlay-opacity="0.8">
        <v-card v-for="note in active_notifications" :key="note.title" class="my-2 mx-auto" width="430">
          <v-card-title :class="`px-2 body-2 ${[note.type == 'info' ? 'primary' : 'warning']}`">
            {{note.title}}
          </v-card-title>
          <v-card-text class="pa-2 caption" v-html="note.message"></v-card-text>
        </v-card>
        <v-btn
          v-if="!notifications_visible && notifications.length" @click="show_hide_notifications()" small
        >
          More
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
        <template v-if="notifications_visible">
          <v-card v-for="note in notifications" :key="`all_${note.title}`" class="my-2 mx-auto" width="430">
            <v-card-title :class="`px-2 body-2 ${[note.type == 'info' ? 'primary' : 'warning']}`">
              {{note.title}}
            </v-card-title>
            <v-card-text class="pa-2 caption" v-html="note.message"></v-card-text>
          </v-card>
          <v-btn
            v-if="notifications_visible" @click="show_hide_notifications()" small
          >
            Less
            <v-icon right>mdi-chevron-up</v-icon>
          </v-btn>
        </template>
      </v-dialog>
      
      <v-dialog v-model="forgot_password_dialog" fullscreen transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dense>
            <v-toolbar-title class="text-uppercase grey--text mr-2 mt-1 body-1" style="cursor:pointer">
              <span>
                <v-avatar width="32px" height="32px" min-width="32px" class="gm-logo" tile>
                  <img src="/logo_gm_bw.png" alt="avatar">
                </v-avatar>
              </span>
              <span class="font-weight-light pl-2">Grid</span>
              <span>Markets</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-layout width="50%">
            <v-row class="mt-16" v-if="!forgot_password_reset">
              <v-col :cols="mobile_view ? 1 : 4">&nbsp;</v-col>
              <v-col :cols="mobile_view ? 10 : 4">
                <v-form ref="reset_password_form" lazy-validation>
                  <v-card width="100%">
                      <v-alert v-if="forgot_password_error" class="error my-0 pa-2" tile>
                        <v-icon small class="pb-1">warning</v-icon>
                        <span class="subtitle-1 font-weight-medium pl-2">{{forgot_password_error}}</span>
                      </v-alert>
                      <v-card-title>
                        <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Forgot Password?</span>
                        <v-spacer></v-spacer>
                        <v-btn class="float-right" fab dark x-small text @click="forgot_password_dialog=false">
                          <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text class="py-0">
                          <v-container class="pa-0">
                              <v-row>
                                  <v-col class="py-0" cols="12">
                                      <v-text-field
                                          v-model="forgot_email"
                                          label="Email"
                                          :rules="emailRules"
                                          @keydown.enter.prevent="reset_password"
                                      ></v-text-field>
                                  </v-col>
                              </v-row>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="green darken-1" depressed x-small @click="reset_password">Reset Password</v-btn>
                      </v-card-actions>
                  </v-card>
                </v-form>
              </v-col>
            </v-row>
            <v-row v-else class="mt-16">
              <v-col cols="4">&nbsp;</v-col>
              <v-col cols="4">
                <v-card width="100%" class="caption dense">
                  <v-card-title>
                    <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Password reset request</span>
                    <v-spacer></v-spacer>
                    <v-btn class="float-right" fab dark x-small text @click="forgot_password_dialog=false">
                      <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    A link to reset the password has been sent to your registered email.
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      mobile_view: false,
      linkedin_auth_url: null,
      linkedin_auth: false,
      password_label: "Password or Access Key",
      is_password: false,
      notifications_visible: false,
      active_notifications: [],
      notifications: [],
      notifications_dialog: false,
      text_from_envoy: null,
      envoy_downloading: false,
      login_error: null,
      login_loading : false,
      login_disabled: false,
      forgot_email: '',
      forgot_password_error: null,
      forgot_password_dialog: false,
      forgot_password_reset: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      password: '',
      passwordRules: [
        v => !!v || `${this.password_label} is required`,
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ]
    }
  },
  computed : {
    isLoggedIn : function() { return this.$store.getters.isLoggedIn}
  },
  methods: {
    show_hide_notifications(){
      if (this.notifications_visible) this.notifications_visible = false;
      else this.notifications_visible = true;
    },
    linkedin_signin: function() {
      this.login_error = null;
      this.linkedin_auth = true;

      let post_json = {
        "provider": "linkedin",
        "redirect_uri": `${window.location.origin}/linkedin/callback`
      }

      axios.post(`https://${this.$buyerAPI}/auth?action=authorization`, post_json)
      .then((resp) => {
        window.location.href = resp.data.data.authorization_url;
      })
      .catch(error => {
        var resp = error.response;
        this.linkedin_auth = false;
        if (resp && resp.status == 401){
          this.login_error = resp.data;
        }else{
          this.login_error = error.message
        }
      })
    },
    login: function () {
      this.login_error = null;
      let email = this.email
      let password = this.password
      let ispassword = this.password.length < 25

      if (this.mobile_view && !ispassword){
        this.login_loading = false;
        this.login_error = "Invalid password"
        return;
      }

      this.$store.dispatch('basic_login', { email, password, ispassword })
      .then(() => this.$router.push('/'))
      .catch(error => {
        this.login_loading = false;
        if (error.response){
          if (error.response.status == 401){
            this.login_error = "Invalid Email or Password/Access Key"
          }else{
            this.login_error = error.response.data.error; 
          }
        }else{
          this.login_error = error.message;
        }
      })
    },
    submit: function () {        
      if (this.login_disabled){
        return;
      }
      this.login_loading = true;
      this.login();
    },
    desktop_version_link(){
      window.open("https://www.gridmarkets.com/envoy")
    },
    forgot_password(){
      this.forgot_password_reset = false;
      this.forgot_password_error = null;
      this.forgot_password_dialog = true;
    },
    reset_password(){
      if(!this.$refs.reset_password_form.validate()) {
        return false;
      }

      let post_json = {
        email: this.forgot_email
      }

      axios.post(`https://${this.$buyerAPI}/auth?action=reset_password`, post_json)
      .then(() => {
        this.forgot_password_error = null;
        this.forgot_password_reset = true;
      })
      .catch(error => {
        if (error.response){
          this.forgot_password_error = error.response.data.error;
        }else{
          this.forgot_password_error = error.message;
        }
      })
    },
    getNotifications(){
      axios.get(`https://${this.$buyerAPI}/notifications`)
      .then(resp => {
        this.notifications = (resp.data && resp.data.data) || [];
        this.active_notifications = this.notifications.splice(0,1);
        if (this.active_notifications.length) this.notifications_dialog = true;
      })
      .catch(() => {})
    }
  },
  created : function() {
    if (this.isLoggedIn){
      this.$router.push('/')
      return
    }

    this.email = localStorage.getItem("useremail") || "";
    this.password = localStorage.getItem("userpwd") || "";
    this.is_password = JSON.parse(localStorage.getItem("ispassword")) || false;
    if (this.is_password == "true") {
      this.is_password = true;
    }else{
      this.is_password = false;
    }

    if (["xs", "sm"].indexOf(this.$vuetify.breakpoint.name) > -1){
      this.mobile_view = true;
      this.password_label = "Password";
    }

    this.getNotifications();
  }
}
</script>
